<h1 mat-dialog-title>Link generated</h1>
<div mat-dialog-content>

  <!-- Copy link button -->
  <div class="row">
    <mat-form-field>
      <mat-label>Training url</mat-label>
      <input matInput [(ngModel)]="data.link" [ngModelOptions]="{standalone: true}" readonly>
    </mat-form-field>
    <button mat-stroked-button color="primary" (click)="copyToClipboard(data.link, $event.target)">Copy</button>
  </div>

  <!-- Access code -->
  <div *ngIf="data.accessCode" class="row">
    <mat-form-field>
      <mat-label>Access code</mat-label>
      <input matInput [(ngModel)]="data.accessCode" [ngModelOptions]="{standalone: true}" readonly>
    </mat-form-field>
  </div>

</div>
<div mat-dialog-actions class="actions">
  <button mat-stroked-button [mat-dialog-close]="true">Close</button>
</div>
